import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom'
import {useTheme} from "@mui/material/styles"

import {createColumnHelper, flexRender, getCoreRowModel, useReactTable,} from '@tanstack/react-table';

import Table from '@material-ui/core/Table'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import TableContainer from '@material-ui/core/TableContainer'
import Paper from '@material-ui/core/Paper'
import Switch from '@material-ui/core/Switch'
import Box from '@material-ui/core/Box'
import Header from "../components/core/Header";
import {editSupportStatus, getSupportList} from '../utils/API';
import LoadingComponent from '../components/core/LoadingComponent';
import get from 'lodash.get';
import {isVitrayaInternalUser} from "../constants/UserAuth";

const defaultData = [
    {
        "id": 1,
        "userId": "a4fdc4db3f",
        "email": "vitraya.support1@vitrayatech.com",
        "claimCount": 0,
        "totalClaimCount": 71,
        "status": "OFFLINE",
        "dataStatus": 0,
        "deleted": 0
    },
    {
        "id": 2,
        "userId": "a4fdc4db3f",
        "email": "vitraya.support1@vitrayatech.com",
        "claimCount": 0,
        "totalClaimCount": 71,
        "status": "OFFLINE",
        "dataStatus": 0,
        "deleted": 0
    }
];

const columnHelper = createColumnHelper();

const columns = [
    columnHelper.accessor('id', {
        cell: (info) => info.row.index + 1,
        header: 'Id'
    }),
    columnHelper.accessor('email', {
        cell: (info) => info.getValue(),
        header: 'Email'
    }),
    columnHelper.accessor('totalClaimCount', {
        cell: (info) => info.getValue(),
        header: 'Total Claim Count'
    }),
    columnHelper.accessor('status', {
        cell: (info) => info.getValue(),
        header: 'Status'
    }),
    columnHelper.accessor('status', {
        cell: (info) => {
            const editStatus = (checked) => {
                info.table.options?.meta?.updateStatus(info.row.original['userId'], checked ? 'ONLINE' : 'OFFLINE')
            }
            return <Switch color='primary' checked={info.getValue() !== 'OFFLINE'}
                           onChange={e => editStatus(e.target.checked)}/>
        },
        header: 'Action'
    }),
];

const SupportAllocation = () => {
    const theme = useTheme();

    const [data, setData] = useState(() => []);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        meta: {
            updateStatus: (userId, status) => {
                editSupportStatus(userId, status)
                updateStatusOnPage(userId, status)
            },
        },
    });

    const updateStatusOnPage = (userId, newStatus) => {
        // Find the index of the user in the list
        const userIndex = data.findIndex(user => user.userId === userId);
        if (userIndex !== -1) {
            // If the user exists, update its status
            const updatedUserList = [...data];
            updatedUserList[userIndex].status = newStatus;
            // Update the state with the modified list
            setData(updatedUserList);
        }
    };

    useEffect(async () => {
        const response = await getSupportList(1, 1000)
        setData(get(response, ['data'], []))
        setIsLoading(false)
    }, [])

    if (isLoading) {
        return <LoadingComponent/>
    }

    if (!isVitrayaInternalUser()) {
        navigate('/')
        return <></>
    }

    return (
        <Box
            sx={{
                background: theme.palette.background.default,
                minHeight: "100vh",
            }}
        >
            <Header/>
            <Box p={'8rem'}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            {table.getHeaderGroups().map((headerGroup) => (
                                <TableRow key={headerGroup.id}>
                                    {headerGroup.headers.map((header) => (
                                        <TableCell key={header.id}>
                                            {header.isPlaceholder
                                                ? null
                                                : flexRender(
                                                    header.column.columnDef.header,
                                                    header.getContext()
                                                )}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableHead>
                        <TableBody>
                            {table.getRowModel().rows.map((row) => (
                                <TableRow key={row.id}>
                                    {row.getVisibleCells().map((cell) => (
                                        <TableCell key={cell.id}>
                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
}

export default SupportAllocation;